import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-demo',
    auth: {
      // Siehe leistungserbringer-webapp/environment.demo.ts: geteilter Auth0-Dev-Tenant mit
      // env-test, nur die Demo-URLs kommen an der bestehenden TST-Application dazu.
      domain: 'dev-c4be3obj05th0lrq.eu.auth0.com',
      clientId: 'co0SMgyMtG6AiA5xWJuH82Z1qXkSZqK0',
      authorizationParams: {
        audience: 'https://tst-intern-backend.azurewebsites.net',
        scope: 'openid profile email offline_access',
        redirect_uri: window.location.origin,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: ['https://demo-internal-restbackend-eze3gtfsgwedbhdj.germanywestcentral-01.azurewebsites.net/api/*'],
      },
    },
    api: {
      internalUrl: 'https://demo-internal-restbackend-eze3gtfsgwedbhdj.germanywestcentral-01.azurewebsites.net/api',
    },
    leistungserbringerWebappBaseUrl: 'https://one-demo.saniup.de',
    selfserviceWebappBaseUrl: 'https://versorgung-demo.saniup.de',
    selfserviceApiBaseUrl: 'https://demo-patientenselfservice-restbackend-f2c3apere3axdzgf.germanywestcentral-01.azurewebsites.net',
  }
}
